<ion-header [translucent]="false" class="ion-no-border custom-header" mode="md">
  <ion-toolbar>
    <ion-title class="modal-title">{{'edit_frame' | translate}}</ion-title>
    <ion-buttons slot="end">
      <ion-button fill="clear" (click)="cancel()">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content [fullscreen]="true" class="ion-padding">
  <div class="configuration-container">
    <div class="select-group">
      <label class="select-label">{{ 'brand' | translate }}</label>
      <ion-select [(ngModel)]="selectedManufacturerId" (ionChange)="onManufacturerChange()" interface="popover"
        class="styled-select" cssClass="select-popover">
        <ion-select-option *ngFor="let m of manufacturers" [value]="m.id">
          {{ m.name }}
        </ion-select-option>
      </ion-select>
    </div>

    <!-- System Dropdown (Editable) -->
    <div class="select-group">
      <label class="select-label">{{ 'system' | translate }}</label>
      <!-- <ion-select [(ngModel)]="selectedSystemId" (ionChange)="onSystemChange()" interface="popover"
        class="styled-select" cssClass="select-popover">
        <ion-select-option *ngFor="let sys of filteredSystems" [value]="sys.id">
          {{ sys.name }}{{ sys.variant ? ' — ' + (sys.variant | translate) : '' }}
        </ion-select-option>
      </ion-select> -->
      <div class="styled-select custom-select-trigger" (click)="openSystemPopover($event)">
          <span class="selected-text" *ngIf="selectedSystem; else systemPlaceholder">
            {{ selectedSystem.name }}
            <span *ngIf="selectedSystem.variant">
              — {{ selectedSystem.variant | translate }}
            </span>
          </span>
          <ng-template #systemPlaceholder>
            <span class="placeholder"></span>
          </ng-template>
          <ion-icon name="chevron-down-outline"></ion-icon>
        </div>
    </div>

    <!-- Type (Read-only) -->
    <div class="select-group" *ngIf="selectedSystem">
      <label class="select-label">{{ 'type' | translate }}</label>
      <ion-select [value]="selectedSystem.frameType" interface="popover" class="styled-select" cssClass="select-popover"
        disabled>
        <ion-select-option [value]="selectedSystem.frameType">
          {{ selectedSystem.frameType | translate }}
        </ion-select-option>
      </ion-select>
    </div>
    <div class="select-group" *ngIf="selectedSystem?.variant">
      <label class="select-label">{{ 'variant' | translate }}</label>
      <p style="margin: 0; font-size: 14px;">{{ (selectedSystem?.variant || '') | translate}}</p>
    </div>
    <!-- Mapped Profiles List -->
    <ion-list *ngIf="mappedProfiles.length > 0">
      <ng-container *ngFor="let mapped of mappedProfiles">
        <ion-item lines="none" class="cardDiv">
          <div class="image-container">
            <img [src]="mapped.expertImage" [alt]="mapped.label" class="square-image" />
          </div>
          <div class="content-container">
            <h5 class="card-title">{{ mapped.label | translate }}</h5>
            <ion-select *ngIf="hasMultipleProfiles(mapped)" [(ngModel)]="mapped.selectedRelId"
              (ionChange)="onProfileChange(mapped, mapped.selectedRelId)" interface="popover" class="profile-selector">
              <ion-select-option *ngFor="let prof of mapped.allProfiles" [value]="prof.relIDs[0]">
                {{ prof.name }}
              </ion-select-option>
            </ion-select>
            <p class="card-subtitle" *ngIf="!hasMultipleProfiles(mapped) && mapped?.profile">{{ mapped?.profile?.name }}
            </p>
            <div *ngIf="mapped.profile">
              <p class="card-subtitle">Uf = {{ getDisplayableUf(mapped.profile.uf) }} W/m²K</p>
              <p class="card-subtitle">Width: {{ (mapped.profile.wf) }}m</p>
            </div>
          </div>
        </ion-item>
      </ng-container>
    </ion-list>
  </div>
  <p style="text-align: left;">{{'FRAME_BRAND_NOTE' | translate}}</p>
</ion-content>
<ion-footer [translucent]="false" class="ion-no-border">
  <div class="button-container">
    <ion-button fill="outline" class="cancel-btn" (click)="cancel()" expand="block">
      {{'cancel' | translate}}
    </ion-button>
    <ion-button class="next-btn" (click)="validate()" expand="block">
      {{'validate' |translate}}
    </ion-button>
  </div>
</ion-footer>